import { createAction } from "redux-starter-kit";
import { SHOW_COPY_MODAL } from "../actionTypes";

export const showCopyModalAction = createAction(SHOW_COPY_MODAL);
